import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Type } from "class-transformer";
import { EmployeeDocumentCategoryDto } from "@/core/features/employee-document-categories/employee-document-category.dto";
import { EmployeeDocumentVersionDto } from "@/core/features/employee-documents/employee-document-version.dto";

export class EmployeeDocumentDto extends BaseEntityDto {
  userId: string;
  categoryId: string;

  @Type(() => EmployeeDocumentCategoryDto)
  category: EmployeeDocumentCategoryDto;

  @Type(() => EmployeeDocumentVersionDto)
  versions?: EmployeeDocumentVersionDto[];

  get latestVersion(): EmployeeDocumentVersionDto | null {
    if (!this.versions?.length) return null;
    return [...this.versions].sort((left, right) => right.versionNumber - left.versionNumber)[0];
  }
}
